// extracted by mini-css-extract-plugin
export default {"StaticDiffPreview":"StaticUnifiedDiffPreview-module__StaticDiffPreview--R_cuY","HeaderContainer":"StaticUnifiedDiffPreview-module__HeaderContainer--l3mJd"};